import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1dd82064"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col h-full px-[24px] mx-auto w-auto min-w-full" }
const _hoisted_2 = { class: "max-w-[1624px] h-full w-full mx-auto flex flex-col" }
const _hoisted_3 = { class: "relative flex-grow mt-[12px] mb-[24px]" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "absolute w-full h-full"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center items-center h-full" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "z-max absolute incredicon-spinner infinite-spinner-animation !text-[50px] flex text-System/app_primary !mr-0" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]

import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import WorkloadsSummary from '@/views/workloads/components/workloadsSummary.vue';
import WorkloadsTableNavbar from '@/views/workloads/components/workloadsTableNavbar.vue';
import WorkloadsTable from '@/views/workloads/components/workloadsTable.vue';
import WorkloadsTimeDurationSelect from '@/views/workloads/components/workloadsTimeDurationSelect.vue';
import EmptyBuildsSearch from '@/views/workloads/components/tableComponents/emptyWorkloads.vue';
import { useI18n } from 'vue-i18n';
import moment from 'moment';
import { computed, inject } from 'vue';
import { IKWorkloadsPageData } from '@/views/workloads/workloads.injectionKeys';
import { useWorkloadsDataProvider, useWorkloadsPersistentDataProvider } from '@/views/workloads/workloads.helpers';
import { useWorkloadsColumnsManagementProvider } from '@/views/workloads/components/navbarComponents/manageColumns/manage-columns.helpers';


export default /*#__PURE__*/_defineComponent({
  __name: 'workloads',
  setup(__props) {

useWorkloadsPersistentDataProvider();
useWorkloadsDataProvider();
useWorkloadsColumnsManagementProvider();

const { t } = useI18n();
const workloadsData = inject(IKWorkloadsPageData);

const isWorkloadsDataLoading = computed(() => workloadsData?.GQL?.loading.value);

const resetLast14Days = () => {
  workloadsData?.filter.clear();
  workloadsData?.filter?.setTimeFrame([
    {
      from: moment().subtract(13, 'days').startOf('day').unix() * 1000,
      to: moment().endOf('day').unix() * 1000,
    },
  ]);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { style: {"margin":"0 auto","width":"100%","display":"inline-flex","flex-direction":"column"} }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(WorkloadsTimeDurationSelect, { class: "mb-[8px]" }),
          _createVNode(WorkloadsSummary, { class: "mb-[16px]" }),
          _createVNode(WorkloadsTableNavbar),
          _createElementVNode("div", _hoisted_3, [
            (_unref(workloadsData)?.isFilterOutOfLicenseRange.value)
              ? (_openBlock(), _createBlock(EmptyBuildsSearch, {
                  key: 0,
                  "button-text": _unref(t)('workloads.workloadsTable.outOfRangeBuildsDate.buttonText'),
                  class: "no-workloads-available flex-grow w-full h-[calc(100%-40px)] bg-System/app_white",
                  "has-filters-applied": true,
                  "img-type": "builds",
                  title: _unref(t)('workloads.workloadsTable.outOfRangeBuildsDate.title'),
                  subtitle: _unref(t)('workloads.workloadsTable.outOfRangeBuildsDate.subtitle'),
                  onClearFilters: _cache[0] || (_cache[0] = () => resetLast14Days())
                }, null, 8, ["button-text", "title", "subtitle"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_unref(isWorkloadsDataLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                    : _createCommentVNode("", true),
                  _createVNode(WorkloadsTable, {
                    class: _normalizeClass([{ 'blur-sm pointer-events-none': _unref(isWorkloadsDataLoading) }, "w-full h-full absolute"])
                  }, null, 8, ["class"])
                ]))
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})